import vuex from "../vuex";
import UserPreferencesModule from "./store";

export default {
	install() {
		vuex.registerModule("user-preferences", UserPreferencesModule);
	}
};
